import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import DOMPurify from "dompurify";
import { LoggedIn } from "../utils/helper";
import Reveal from "../components/shared/reveal";
import Divider from "../components/shared/divider";
import styled from "styled-components";
import { FaRegCircleDot } from "react-icons/fa6";
import EditLink from "../components/shared/edit-link";

const Services = () => {
  const userLoggedIn = LoggedIn();
  const [posts, setPosts] = useState([]);
  const [header, ...details] = posts;
  const STATIC_URL = process.env.REACT_APP_STATIC_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const URL = process.env.REACT_APP_API_URL;
        const res = await axios.get(`${URL}/posts?section=services`);
        setPosts(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []); //

  return (
    <Wrapper>
      <div id="servicelist" className="aboutContainer">
        <div className="aboutSubContainer">
          {/* HEADING OF SECTION */}
          <div className="heading">
            <div>
              {header && <EditLink id={header.id} />}

              <div className="headerTitle">{header && header.title}</div>
              <Divider />
              <div
                className="headerText"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(header && header.desc),
                }}
              ></div>
            </div>
          </div>

          {/* DETAIL OF SECTION */}

          <div className="cardsContainer">
            {details.map((post, index) => (
              <div className="cardContainer" key={post.id}>
                <Reveal
                  column={index}
                  card={
                    <div className="Card">
                      {post.id && (
                        <div className="cardBody">
                          {post && <EditLink header={header} id={post.id} />}
                          <div className="dotDiv">
                            <FaRegCircleDot color="#18d26e" size="25px" />
                          </div>
                          <div className="cardDef">
                            <div className="cardHeader">{post.title}</div>
                            <div
                              className="cardText"
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(post.desc),
                              }}
                            ></div>
                          </div>
                        </div>
                      )}
                    </div>
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Services;
const Wrapper = styled.div`
  .aboutContainer {
    display: flex;
    width: 100%;
    height: auto;

    .aboutSubContainer {
      width: 90vw;
      flex: 2;
      flex-direction: column;
      border-style: none;
      position: relative;
      justify-content: center;
      text-align: center;
      margin-left: 10vw;
      margin-right: 10vw;
      margin-top: 0px;

      .heading {
        margin-bottom: 2px;

        .headerTitle {
          padding-top: 30px;
          font-size: 32px;
          font-weight: 600;
        }

        /* Header Text */
        .headerText {
          font-size: 14px;
          font-weight: 200;
          margin-left: 20px;
          margin-right: 20px;
          margin-top: 18px;
          margin-bottom: 40px;
        }
      }
      /* Details Section; */
      .cardsContainer {
        display: flex;
        flex: 3;
        flex-wrap: wrap; /* Enables wrapping of items */
        flex-direction: row;
        justify-content: space-around; /* Aligns items on the main axis */
        align-items: center; /* Aligns items on the cross axis */

        .cardContainer {
          flex: 1 0 30%; /* This is what made the columns flex correctly */
          position: relative;
          top: 0;
          text-align: center;
          font-size: 10px;
          align-self: flex-start;
          border-style: none;

          .Card {
            border-style: none;

            .cardBody {
              border-style: none;
              display: flex;
              flex: 8;
              flex-direction: row;
              align-items: center;

              .dotDiv {
                display: flex;
                flex: 1;
                height: 200px;
                align-self: flex-start;
                justify-content: center;

                .cardDot {
                  display: flex;
                  border-color: var(--accentcolor0);
                  border-style: solid;
                  border-size: 0.2px;
                  background-color: white;
                  border-radius: 50%;
                  width: 27px;
                  height: 27px;
                  align-self: flex-start;
                  justify-content: center;

                  .cardDot2 {
                    background-color: var(--accentcolor1);
                    border-radius: 50%;
                    width: 22px;
                    height: 22px;
                    margin-top: 1px;
                    align-vertical: center;
                  }
                }
              }
              .cardDef {
                flex: 7;
                align-self: flex-start;
                margin-bottom: 5px;

                .cardHeader {
                  font-size: 24px;
                  font-weight: 800;
                  margin-left: 10px;
                  margin-right: 20px;
                  margin-bottom: 14px;
                  align-self: flex-start;
                  text-align: left;
                }

                .cardText {
                  font-size: 20px;
                  line-height: 24px;
                  padding-bottom: 5px;
                  padding-left: 12px;
                  padding-right: 12px;
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .aboutContainer {
      width: 100vw;

      .aboutSubContainer {
        .heading {
          .headerTitle {
            font-size: 32px;
          }

          /* Header Text */
          .headerText {
            font-size: 14px;
          }
        }
        /* Details Section; */
        .cardsContainer {
          .cardContainer {
            .Card {
              .cardBody {
                .dotDiv {
                  .cardDot {
                    width: 24px;
                    height: 24px;
                    .cardDot2 {
                      width: 22px;
                      height: 22px;
                      margin-top: 2px;
                      align-vertical: center;
                    }
                  }
                }
                .cardDef {
                  .cardHeader {
                    font-size: 20px;
                    margin-bottom: 5px;
                    margin-top: 0px;
                  }
                  .cardText {
                    font-size: 16px;
                    line-height: 20px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
